import { IconButton } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';

export default function GenersItemMenu({ item, index, handleMenuOpen, handleMenuClose }) {
    return (
        <IconButton
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
              backgroundColor: "rgba(0,0,0,0.5)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
              zIndex: 3,
            }}
            onClick={(event) => {
              handleMenuOpen(event, item, index)
            }}
          >
            <MoreVertIcon />
          </IconButton>
    )
}   